import { render, staticRenderFns } from "./section1.vue?vue&type=template&id=8455668a&scoped=true"
import script from "./section1.vue?vue&type=script&lang=js"
export * from "./section1.vue?vue&type=script&lang=js"
import style0 from "./section1.vue?vue&type=style&index=0&id=8455668a&prod&scoped=true&lang=less"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8455668a",
  null
  
)

export default component.exports